import { ReactComponent as IconChevron } from "../../assets/icons/chevron.svg";

export interface RightLeftArrowsProps {
  onClick: (type: "left" | "right") => void;
}

export const RightLeftArrows: React.FC<RightLeftArrowsProps> = ({ onClick }) => {
  const renderArrow = (
    direction: 'left' | 'right',
  ) => {
    return (
      <div 
        onClick={(e) => {
          e.stopPropagation();
          onClick(direction);
        }}
        style={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          left: direction === "left" ? "0" : "unset",
          right: direction === "right" ? "0" : "unset",
          color: "white",
          fontWeight: "bold",
          fontSize: "2em",
          padding: "0.5em",
          cursor: "pointer",
          borderRadius: "0.5em",
          backgroundColor: "#FFFFFF50",
        }}
      >
        {
          direction === "left" ? (
            <IconChevron width={20} height={20} style={{ transform: "rotate(-90deg)" }} />
          ) : (
            <IconChevron width={20} height={20} style={{ transform: "rotate(90deg)" }} />
          )
        }
      </div>
    );
  };
  return (
    <>
      {renderArrow("left")}
      {renderArrow("right")}
    </>
  );
}
